import { SapEccCopySource } from './../../../pipeline/copysource/sap-ecc.copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from '../../value.adapter';
import { stringIsNullOrEmpty } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapEccCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        httpRequestTimeout: '*'
    }
})
export class SapEccCopySourceAdapter extends CopySourceAdapter<SapEccCopySource, Model.SapEccSource> {
    protected override async _toResource(copySource: SapEccCopySource): Promise<Model.SapEccSource> {
        const result: Model.SapEccSource = this._toTabularResource(
            copySource,
            Metamodel.modelFor(SapEccCopySource).name
        );
        result.httpRequestTimeout = ValueAdapter.toResource(copySource, SapEccCopySource.HTTP_REQUEST_TIMEOUT);
        // clear out '' from resource, backend doesn't support ''
        if (stringIsNullOrEmpty(result.httpRequestTimeout)) {
            result.httpRequestTimeout = undefined;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.SapEccSource,
        copyActivity: CopyActivity
    ): Promise<SapEccCopySource> {
        const result: SapEccCopySource = this._toTabularModel(resource, copyActivity, SapEccCopySource.MODEL);
        if (resource.httpRequestTimeout != null) {
            ValueAdapter.toModel(result, SapEccCopySource.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        } else {
            // clear default value for all existing resources
            result.httpRequestTimeout = undefined;
        }
        return result;
    }
}
